import ContactsIcon from '@mui/icons-material/Contacts';

export { ContactList } from './List';
export { ContactShow } from './Show';
export { ContactEdit } from './Edit';
export { ContactCreate } from './Create';
export const ContactIcon = ContactsIcon;
